import { render, staticRenderFns } from "./feeConfigManageList.vue?vue&type=template&id=6521c9b6&scoped=true"
import script from "./feeConfigManageList.vue?vue&type=script&lang=js"
export * from "./feeConfigManageList.vue?vue&type=script&lang=js"
import style0 from "./feeConfigManageList.vue?vue&type=style&index=0&id=6521c9b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6521c9b6",
  null
  
)

export default component.exports